import { render, staticRenderFns } from "./ConfigRoles.vue?vue&type=template&id=590f29ec&scoped=true&"
import script from "./ConfigRoles.vue?vue&type=script&lang=js&"
export * from "./ConfigRoles.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRoles.vue?vue&type=style&index=0&id=590f29ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590f29ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590f29ec')) {
      api.createRecord('590f29ec', component.options)
    } else {
      api.reload('590f29ec', component.options)
    }
    module.hot.accept("./ConfigRoles.vue?vue&type=template&id=590f29ec&scoped=true&", function () {
      api.rerender('590f29ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/vistas/ConfigRoles.vue"
export default component.exports